import { Card, CardContent, Collapse } from '@mui/material'
import styled from 'styled-components'
import { COLORS } from 'utils'

export const CollapseContainer = styled.div`
  max-height: 104px;
  background: ${COLORS.headerColor};
  margin-top: 14px;
  /* box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25); */
`

export const CollapseInfo = styled.div`
  margin-top: 4px;
  margin-bottom: -7px;
  button {
    max-width: 225px;
  }
`

export const CollapseStyled = styled(Collapse)``
export const CardStyled = styled(Card)`
  margin-top: 14px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
  background: ${COLORS.white};
`

interface CardContentProps {
  isHeader?: boolean
}

export const CardContentStyled = styled(CardContent)<CardContentProps>`
  background: ${({ isHeader }) =>
    isHeader ? COLORS.headerColor : COLORS.white};
`

export const CollapseTitleStyled = styled.div`
  background: ${COLORS.secondary};
  width: -webkit-max-content;
  width: -moz-max-content;
  padding: 5px 40px 5px 30px;
  clip-path: polygon(5% 0, 100% 0, 95% 100%, 0 100%);
`
